import React from 'react';
import classNames from 'classnames';

import ManageAd from './manageAd';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';
import EmptyBack from 'assets/images/noImage/background store 4.svg';
import {gradeConvertor} from 'components/mainCards/subCardSwitcher/uitilities';
import {textLengthLimiter} from 'components/mainCards/helper';
import BadgeSwitcher from './badgeSwicher';

interface CardAdProps {
  post: IGetMyWantedsResults;
  wrapperClassName?: string;
  app: 'farm' | 'wholesaler';
  type: 'post';
  refetch: () => void;
}
const CardAd = ({post, app, type, wrapperClassName, refetch}: CardAdProps) => {
  return (
    <div
      className={classNames(
        'flex bg-white justify-between rounded-lg h-36 mx-2 px-2 py-4  shadow-md w-72 mb-3 gap-2',
        wrapperClassName,
      )}
    >
      <div className="relative flex items-center !w-[128px]">
        <div className=" absolute  right-1 text-xs text-created-day top-[10px]   px-2 rounded-3xl">
          <BadgeSwitcher
            status={post.status}
            createdDate={timeFromCreated(post.created_at)}
            isExpired={post?.[post.type]?.is_expired}
            isSold={
              post.sale_status?.is_saled ? post.sale_status?.is_saled : false
            }
          />
        </div>
        <img
          className="object-cover  rounded-md flex-none w-[128px] h-[128px]"
          src={
            post.main_image?.image_128 ? post.main_image.image_128 : EmptyBack
          }
          alt={post.title}
          width={120}
          height={103}
        />
      </div>
      <div className="flex flex-col grow pl-2 justify-between gap-4 h-full w-[55%]">
        <div className="flex justify-between gap-1  w-full">
          <p className=" text-black w-[90%]   overflow-hidden  break-words !max-w-[154px]   text-sm font-extrabold text-start">
            {textLengthLimiter(post.title, 45)}
          </p>
          {post.grade && (
            <span className="w-[23px]">
              {gradeConvertor[Number(post.grade)]}
            </span>
          )}
        </div>
        <div className="h-[50%] flex flex-col gap-2 justify-center">
          <ManageAd
            post={post}
            cardType={post.post_type}
            type={type}
            app={app}
            guid={post.guid}
            status={post.status}
            refetch={refetch}
          />
        </div>
      </div>
    </div>
  );
};

export default CardAd;
